module.exports = __webpack_public_path__ + "img/user-3.e5c2b8f0.svg";